import type { UnknownAction } from "redux";

import type { FormInstanceId } from "./updateFormReducer";

export interface UpdateBookingFormSetVehicleTypeAction extends UnknownAction {
  payload: {
    id: FormInstanceId;
  };
  type: "UPDATE_FORM:TRAVELLED_VEHICLE:SET_VEHICLE_TYPE";
}

export const setVehicleTypeFromTravelledVehicle = (
  id: FormInstanceId,
): UpdateBookingFormSetVehicleTypeAction => ({
  payload: {
    id,
  },
  type: "UPDATE_FORM:TRAVELLED_VEHICLE:SET_VEHICLE_TYPE",
});

export interface UpdateBookingFormRestoreDimensionAction extends UnknownAction {
  payload: {
    id: FormInstanceId;
    dimensionName: "height" | "length";
  };
  type: "UPDATE_FORM:TRAVELLED_VEHICLE:RESTORE_DIMENSION";
}

export const restoreDimensionFromTravelledVehicle = (
  id: FormInstanceId,
  dimensionName: "height" | "length",
): UpdateBookingFormRestoreDimensionAction => ({
  payload: {
    dimensionName,
    id,
  },
  type: "UPDATE_FORM:TRAVELLED_VEHICLE:RESTORE_DIMENSION",
});
